const translations = {
    es: {
        sensorconfig: "Configuración sensor",
        name: "Nombre",
        model: "Modelo",
        power: "Potencia",
        vacuum: "Vaciado",
        filling: "Llenado",
        confsens: "Sensor",
        confdist: "Distancia",
        "confdist.0": "Corto",
        "confdist.1": "Largo",
        "confdist.2": "Ambos",
        type: "Tipo",
        standalone: "Independiente",
        multiple: "Multiple",
        saturation: "Saturación",
        pulses: "Pulsos",
        hysterisis: "Histeresis",
        threshold: "Umbral",
        distance: "Distancia",
        interval: "Intervalo"

    },
    en: {
        sensorconfig: "Sensor configuration",
        name: "Name",
        model: "Model",
        power: "Power",
        vacuum: "Emptying",
        filling: "Filling",
        confsens: "Sensor",
        confdist: "Distance",
        "confdist.0": "Short",
        "confdist.1": "Long",
        "confdist.2": "Both",
        type: "Type",
        standalone: "Standalone",
        multiple: "Multiple",
        saturation: "Saturation",
        pulses: "Pulses",
        hysterisis: "Hysterisis",
        threshold: "Threshold",
        distance: "Distance",
        interval: "Interval"

    }
}
export default translations